export class Fases {
    fase1 = false;
    fase2 = false;
    fase3 = false;
    fase4 = false;
    fase5 = false;
    fase6 = false;
    fase7 = false;

    bloqueo1 = false;
    bloqueo2 = false;
    bloqueo3 = false;
    bloqueo4 = false;
    bloqueo5 = false;
    bloqueo6 = false;
    bloqueo7 = false;

    activa1 = false;
    activa2 = false;
    activa3 = false;
    activa4 = false;
    activa5 = false;
    activa6 = false;
    activa7 = false;

    constructor() {
        // This is intentional
    }
}